<template>
  <b-card
    :title="$t('label_reports_consolidate_pillarSummary_title')"
    :style="{ minHeight: height }"
    style="padding: 1rem"
    :class="compact ? 'compact' : ''"
  >
    <b-row>
      <b-col>
        <p class="card-text">
          {{ $t("label_reports_consolidate_pillarSummary_description") }}
        </p>
      </b-col>
    </b-row>
    <template v-if="sectionToDisplay">
      <template v-for="(indicator, key) in indicatorsData">
        <b-row
          v-if="
            sectionToDisplay.firstIndicator <= key &&
            sectionToDisplay.lastIndicator > key
          "
          :key="key"
          style="border-bottom: 1px solid #000"
        >
          <b-col>
            <p>
              <strong>{{ $t(indicator.acronym) }}</strong> -
              {{ $t(indicator.name) }}
            </p>
            <template-indicator-bullet-consolidated
              :pillar-id="pillarId"
              :indicator-id="indicator.id"
            />
          </b-col>
        </b-row>
      </template>
    </template>
    <template v-else>
      <b-row
        v-for="(indicator, key) in indicatorsData"
        :key="key"
        style="border-bottom: 1px solid #000"
      >
        <b-col>
          <p>
            <strong>{{ $t(indicator.acronym) }}</strong> -
            {{ $t(indicator.name) }}
          </p>
          <template-indicator-bullet-consolidated
            :pillar-id="pillarId"
            :indicator-id="indicator.id"
          />
        </b-col>
      </b-row>
    </template>
  </b-card>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import TemplateIndicatorBulletConsolidated from "../template/_template-indicator-bullet-consolidated";
export default {
  name: "CardChartPillarSummaryConsolidated",
  components: { TemplateIndicatorBulletConsolidated },
  props: {
    pillarId: {
      type: String,
      default: "PP",
    },
    height: {
      type: String,
      default: "auto",
    },
    compact: {
      type: Boolean,
      default: false,
    },
    sectionToDisplay: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      indicatorsData: true,
    };
  },
  computed: mapGetters([
    "indicatorsDataByPillarIdConsolidated",
    "pillarDataConsolidated",
  ]),
  methods: {
    ...mapMutations(["setCurrentIndicatorIdConsolidated"]),
  },
  watch: {
    pillarIdConsolidated: function () {
      this.indicatorsData = this.indicatorsDataByPillarIdConsolidated(
        this.pillarId
      );
    },
  },
  mounted() {
    this.indicatorsData = this.indicatorsDataByPillarIdConsolidated(
      this.pillarId
    );
  },
};
</script>

<style lang="sass" scoped>
h3
  font-size: 1.5rem
  margin-top: 40px
.card-text
  margin-bottom: 1rem
p
  margin: 0rem
  margin-top: 15px
.bullet-graph
  display: flex
  align-items: center

.compact p
  font-size: 0.8rem
</style>
